module.exports = __webpack_public_path__ + "static/media/PM88.73fc05a8.png";